import { render, staticRenderFns } from "./CreateRequireForm.vue?vue&type=template&id=52ebbbc6&scoped=true"
import script from "./CreateRequireForm.vue?vue&type=script&lang=js"
export * from "./CreateRequireForm.vue?vue&type=script&lang=js"
import style0 from "./CreateRequireForm.vue?vue&type=style&index=0&id=52ebbbc6&prod&lang=scss&scoped=true"
import style1 from "./CreateRequireForm.vue?vue&type=style&index=1&id=52ebbbc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ebbbc6",
  null
  
)

export default component.exports